import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import UserService from "../../apiServices/UserService";
import BottomPanel from "../../components/BottomPanel";
import { TextField } from 'react-md';

class UpdateUserInfo extends Component {

    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            user_name: '',
            user_phone: '',
            user_email: '',
            hiddenBtn: false,
        };
    }

    componentDidMount() {
        let userInfo = JSON.parse(localStorage.getItem('user_info'));
        if (userInfo){
            this.setState({user_name: userInfo.name, user_phone: userInfo.phone, user_email: userInfo.email})
        }else{
            UserService.fetchMe().then(response => {
                let userInfo = response.data;
                this.setState({
                    user_name: userInfo.name,
                    user_phone: userInfo.phone,
                    user_email: userInfo.email,
                });
            });
        }
    }

    formSubmit = () => {
        this.setState({hiddenBtn: true});
        this.props.history.push('/');
    };

    render() {
        return (
            <div className='App-block'>
                <DefaultLayout {...this.props} title="Cập nhật thông tin tài khoản" classNameContent="bgWhite" page_type={1} hiddenFt={true}>
                    <div className="wrap-content">
                        <TextField
                            id="user_name"
                            label="Họ tên"
                            className="md-cell md-cell--12"
                            type='text'
                            value={this.state.user_name}
                            onChange={e => this.setState({user_name: e})}
                        />

                        <TextField
                            id="user_phone"
                            label="Số điện thoại"
                            className="md-cell md-cell--12"
                            type='number'
                            value={this.state.user_phone}
                            onChange={e => this.setState({user_phone: e})}
                        />

                        <TextField
                            id="user_email"
                            label="Email"
                            className="md-cell md-cell--12"
                            type='email'
                            value={this.state.user_email}
                            onChange={e => this.setState({user_email: e})}
                        />
                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Cập nhật thông tin"} actionType='summit'/>
            </div>
        )
    }
}

export default (withTranslation())(UpdateUserInfo);
